/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutRequestBase,
  OptOutRequestBaseOptional,
  OptOutRequestBaseMetaI,
  OptOutRequestBaseTrackedI,
} from "./opt-out-request-base";
import {
  OptOutRequestBaseTracked,
  OptOutRequestBaseMeta,
} from "./opt-out-request-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  OptOutRequestRef,
  OptOutRequestRefOptional,
  OptOutRequestRefMetaI,
  OptOutRequestRefTrackedI,
} from "./opt-out-request-ref";
import {
  OptOutRequestRefTracked,
  OptOutRequestRefMeta,
} from "./opt-out-request-ref";

/**
 *
 * @export
 * @interface OptOutRequestFull
 */
export interface OptOutRequestFullOptional extends OptOutRequestBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestFull
   */
  reqId?: number;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestFull
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestFull
   */
  token?: string;
}

export interface OptOutRequestFull
  extends OptOutRequestFullOptional, OptOutRequestBase, OptOutRequestRef {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestFull
   */
  reqId: number;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestFull
   */
  doNotSend?: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestFull
   */
  token?: string;
}

export interface OptOutRequestFullTrackedI extends OptOutRequestBaseOptional {
  /**
   *
   * @type {number}
   * @memberof OptOutRequestFull
   */
  reqId?: number;
  reqIdIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof OptOutRequestFull
   */
  doNotSend?: boolean;
  doNotSendIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof OptOutRequestFull
   */
  token?: string;
  tokenIsSet: boolean;
}

transformDatesMap.set(
  "OptOutRequestFull",
  function (model: OptOutRequestFull) {},
);

export type OptOutRequestFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  reqId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  doNotSend: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  token: PropertyMeta<MetaTypeBase<string>>;
}>;

export var OptOutRequestFullMeta: OptOutRequestFullMetaI =
  {} as OptOutRequestFullMetaI;
OptOutRequestFullMeta = typeMeta("OptOutRequestFull", {
  reqId: propertyMeta("reqId", false, true, true, MetaTypesBase.number),
  doNotSend: propertyMeta(
    "doNotSend",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  token: propertyMeta("token", false, false, false, MetaTypesBase.string),
});

const metaI = OptOutRequestFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([OptOutRequestRefMeta]);
  metaI.reqId.inheritedFrom = OptOutRequestRefMeta.reqId;
  metaI.interfaces = metaI.interfaces.concat([OptOutRequestBaseMeta]);
  metaI.doNotSend.inheritedFrom = OptOutRequestBaseMeta.doNotSend;
  metaI.token.inheritedFrom = OptOutRequestBaseMeta.token;
});

export class OptOutRequestFullTracked
  extends OptOutRequestBaseTracked
  implements OptOutRequestFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  reqId__I?: number = undefined;

  get reqIdIsSet() {
    return this.reqId !== undefined;
  }
  set reqIdIsSet(v: boolean) {}
  set reqId(v: undefined | number) {
    if (v !== undefined) {
      this.reqId__I = v;
      this.reqIdIsSet = true;
    } else {
      this.reqId__I = v || undefined;
      this.reqIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reqId() {
    return this.reqId__I;
  }
  doNotSend__I?: boolean = undefined;
  doNotSendIsSet: boolean = false;
  set doNotSend(v: undefined | boolean) {
    if (v !== undefined) {
      this.doNotSend__I = v;
      this.doNotSendIsSet = true;
    } else {
      this.doNotSend__I = v || undefined;
      this.doNotSendIsSet = false;
    }
    this.changeTracker = true;
  }
  get doNotSend() {
    return this.doNotSend__I;
  }
  token__I?: string = undefined;
  tokenIsSet: boolean = false;
  set token(v: undefined | string) {
    if (v !== undefined) {
      this.token__I = v;
      this.tokenIsSet = true;
    } else {
      this.token__I = v || undefined;
      this.tokenIsSet = false;
    }
    this.changeTracker = true;
  }
  get token() {
    return this.token__I;
  }
  constructor(config?: OptOutRequestFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reqIdIsSet == true && other?.reqIdIsSet == true)
      return this.reqId == other.reqId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reqId) {
      this.reqIdIsSet = true;
    }
  }
  assignFrom(
    config: OptOutRequestFullOptional,
    options?: AssignOptions,
  ): OptOutRequestFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.reqId && this.reqIdApplyFilter(optionsRequired.filter)) {
      this.reqId = config.reqId;
      if (optionsRequired.unassign) this.reqIdIsSet = false;
      else this.reqIdIsSet = true;
    }
    if (config.doNotSend && this.doNotSendApplyFilter(optionsRequired.filter)) {
      this.doNotSend = config.doNotSend;
      if (optionsRequired.unassign) this.doNotSendIsSet = false;
      else this.doNotSendIsSet = true;
    }
    if (config.token && this.tokenApplyFilter(optionsRequired.filter)) {
      this.token = config.token;
      if (optionsRequired.unassign) this.tokenIsSet = false;
      else this.tokenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): OptOutRequestFullTrackedI {
    const cloned = {} as OptOutRequestFullTrackedI;
    if (
      this.reqIdIsSetDeep() &&
      this.reqIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reqIdIsSet = true;
      cloned.reqId = this.reqId;
    } else {
      //cloned.reqIdIsSet = false
    }
    if (
      this.doNotSendIsSetDeep() &&
      this.doNotSendApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.doNotSendIsSet = true;
      cloned.doNotSend = this.doNotSend;
    } else {
      //cloned.doNotSendIsSet = false
    }
    if (
      this.tokenIsSetDeep() &&
      this.tokenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tokenIsSet = true;
      cloned.token = this.token;
    } else {
      //cloned.tokenIsSet = false
    }
    if (!isDeleted(this) && !this.reqIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): OptOutRequestFullTrackedI {
    if (!this.reqIdApplyFilter(filter)) this.reqIdIsSet = false;

    if (!this.doNotSendApplyFilter(filter)) this.doNotSendIsSet = false;

    if (!this.tokenApplyFilter(filter)) this.tokenIsSet = false;

    return this;
  }
  reqIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestFullMeta.reqId,
      OptOutRequestFullMeta,
      this.reqId,
      this,
    );
  }
  reqIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reqIdIsSet && this.reqIdApplyFilter(filter)) return true;

    return false;
  }
  doNotSendApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestFullMeta.doNotSend,
      OptOutRequestFullMeta,
      this.doNotSend,
      this,
    );
  }
  doNotSendIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.doNotSendIsSet && this.doNotSendApplyFilter(filter)) return true;

    return false;
  }
  tokenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      OptOutRequestFullMeta.token,
      OptOutRequestFullMeta,
      this.token,
      this,
    );
  }
  tokenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tokenIsSet && this.tokenApplyFilter(filter)) return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.reqIdIsSetDeep(filter)) return true;
    if (this.doNotSendIsSetDeep(filter)) return true;
    if (this.tokenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
